import React from "react";
import { useEffect, useState } from "react";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import styles from "./Layout.module.scss";
import DataBg from "../components/elements/DataBg";
import BackToTop from "../components/elements/BackToTop";
import Loader from "../components/elements/Loader";

type LayoutProps = {
  children: React.ReactNode;
  wrapperCls?: string;
};

const Layout: React.FC<LayoutProps> = ({ children, wrapperCls }) => {
  const [scroll, setScroll] = useState(false);
  // Mobile Menu
  const [isMobileMenu, setMobileMenu] = useState(false);
  const handleMobileMenu = () => {
    setMobileMenu(!isMobileMenu);
    !isMobileMenu
      ? document.body.classList.add("mobile-menu-visible")
      : document.body.classList.remove("mobile-menu-visible");
  };

  // Popup
  const [isPopup, setPopup] = useState(false);
  const handlePopup = () => setPopup(!isPopup);

  // Sidebar
  const [isSidebar, setSidebar] = useState(false);
  const handleSidebar = () => setSidebar(!isSidebar);

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();

    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > 100; // Check if scrolled more than 100px
      if (scrollCheck !== scroll) {
        setScroll(scrollCheck);
      }
    });
  }, []);
  return (
    <>
      <DataBg />
      {/* <Loader /> */}
      <div className={`page-wrapper ${wrapperCls ? wrapperCls : ""}`} id="#top">
        <Header
          scroll={scroll}
          isMobileMenu={isMobileMenu}
          handleMobileMenu={handleMobileMenu}
          handlePopup={handlePopup}
          isSidebar={isSidebar}
          handleSidebar={handleSidebar}
        />

        {children}

        <Footer />
      </div>
      <BackToTop scroll={scroll} />
    </>
  );
};

export default Layout;

declare global {
  interface Window {
    wow: any;
  }
}
